import React from 'react'
import PropTypes from 'prop-types'
import {Card, CardBody, Form} from 'reactstrap'

class PrintSearch extends React.Component {
    _handleSubmit = (e) => {
        const {onSubmit} = this.props

        if (onSubmit instanceof Function) onSubmit(e)
    }

    _handleChangeInput = (e) => {
        const {onChangeInput} = this.props

        if (onChangeInput instanceof Function) onChangeInput(e)
    }

    render() {
        const {value} = this.props

        return (
            <div className='PrintSearch'>
                <Card>
                    <div className="card-header bg-success text-white header-elements-inline">
                        <h1 className="card-title">In áo - Quét hoặc nhập mã QR</h1>
                    </div>
                    <CardBody>
                        <Form className='d-flex justify-content-center' onSubmit={this._handleSubmit}>

                            <input className='InputSearch form-control' name='barcodeNumber'
                                   value={value}
                                   onChange={this._handleChangeInput}
                                   autoFocus/>
                        </Form>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

PrintSearch.propTypes = {
    onSubmit: PropTypes.func
}

export default PrintSearch
